// third-party
import { createSlice } from "@reduxjs/toolkit";
import { update } from "lodash";
import { createSelector } from "reselect";
import axios from "utils/axios";
import { openSnackbarWithError } from "utils/errors";
import { dispatch } from "../index";
import { openSnackbar } from "./snackbar";
const initialState = {
  tags: [],
  isLoading: false,
  isPosting: false,
  isDeleting: false,
};

const slice = createSlice({
  name: "tags",
  initialState,
  reducers: {
    getTags(state) {
      state.isLoading = true;
    },
    getTagsSuccess(state, action) {
      state.isLoading = false;
      state.tags = action.payload;
    },
    getTagsFailure(state) {
      state.isLoading = false;
    },
    postTag(state) {
      state.isPosting = true;
    },
    postTagSuccess(state, action) {
      state.isPosting = false;
      state.tags.push(action.payload);
      console.log(state.tags);
    },
    postTagFailure(state) {
      state.isPosting = false;
    },
    deleteTag(state) {
      state.isDeleting = true;
    },

    deleteTagSuccess(state, action) {
      state.isDeleting = false;
      const tagId = action.payload;
      state.tags = state.tags.filter((t) => t.id !== tagId);
    },

    deleteTagFailure(state) {
      state.isDeleting = false;
    },

    patchTag(state) {
      state.isUploading = true;
    },

    patchTagSuccess(state, action) {
      state.isUploading = false;
      const tag = action.payload;
      const index = state.tags.findIndex((t) => t.id === tag.id);
      state.tags = update(state.tags, {
        [index]: {
          $set: tag,
        },
      });
    },

    patchTagFailure(state) {
      state.isUploading = false;
    },
  },
});

export const tagNamesSelector = createSelector(
  (state) => state.tags.tags,
  (tags) => {
    return tags.map((tag) => ({
      id: tag.id,
      name: tag.name,
      value: tag.name,
      inputValue: tag.name,
      title: tag.name,
    }));
  }
);

export function getTags(albumId) {
  return async () => {
    try {
      dispatch(slice.actions.getTags());
      const response = await axios.get(
        `/api/v1/photograph_albums/${albumId}/tags`
      );
      dispatch(slice.actions.getTagsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getTagsFailure());
      openSnackbarWithError(error, dispatch);
    }
  };
}

export function postTag(albumId, tagName) {
  return async () => {
    try {
      dispatch(slice.actions.postTag());
      const response = await axios.post(
        `/api/v1/photograph_albums/${albumId}/tags`,
        {
          name: tagName,
        }
      );
      dispatch(slice.actions.postTagSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.postTagFailure());
      openSnackbarWithError(error, dispatch);
    }
  };
}

export function patchTag(albumId, tagId, tag) {
  return async () => {
    try {
      dispatch(slice.actions.patchTag());
      const response = await axios.patch(
        `/api/v1/photograph_albums/${albumId}/tags/${tagId}`,
        {
          ...tag,
        }
      );
      dispatch(slice.actions.patchTagSuccess(response.data));
    } catch (err) {
      dispatch(slice.actions.patchTagFailure());
    }
  };
}

export function deleteTag(albumId, tagId) {
  return async () => {
    try {
      dispatch(slice.actions.deleteTag());
      await axios.delete(`/api/v1/photograph_albums/${albumId}/tags/${tagId}`);
      dispatch(
        openSnackbar({
          open: true,
          message: "Tag correctement supprimé...",
          variant: "alert",
          alert: {
            color: "success",
          },
          close: false,
        })
      );
      dispatch(slice.actions.deleteTagSuccess(tagId));
    } catch (error) {
      dispatch(slice.actions.deleteTagFailure());
    }
  };
}
export default slice.reducer;
